import createAction from './index';

export const SET_EXPIRED = createAction('SET_EXPIRED');

export const setExpired = ({ message, organizationName }) => dispatch => {
  dispatch({ type: SET_EXPIRED, payload: { message, organizationName } });
};
